"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseService = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const index_1 = require("../services/index");
class LicenseService {
    constructor() {
        this.__priority = 100;
        this.hasNoLicense = false;
    }
    init() {
        (0, mobx_1.reaction)(() => index_1.Services.Department.current, () => (this.hasNoLicense = false));
    }
}
exports.LicenseService = LicenseService;
tslib_1.__decorate([
    mobx_1.observable
], LicenseService.prototype, "hasNoLicense", void 0);
//# sourceMappingURL=license.service.js.map